import { COL_NOTIFICATIONS, COL_PRODUCTION_REQUEST_LINES } from '../config/collections'
import { pb } from '../pocketbase'
import type { ProductionRequestLineRecord } from '../types/records'
import { isLineOverdue } from './scheduleCalculations'

const NOTIF_TYPE = 'overdue_lines'

/** Минимальная проверка просроченных строк и in-app уведомление (COL_NOTIFICATIONS). */
export async function checkOverdueAndNotify(recipientId: string): Promise<void> {
  if (!recipientId) return

  let lines: ProductionRequestLineRecord[] = []
  try {
    lines = await pb.collection(COL_PRODUCTION_REQUEST_LINES).getFullList<ProductionRequestLineRecord>({
      filter: 'status != "completed" && status != "shipped" && status != "cancelled"',
      fields: 'id,plannedProduction,status',
    })
  } catch {
    return
  }

  const overdue = lines.filter((ln) => isLineOverdue(ln))
  if (overdue.length === 0) return

  const today = new Date().toISOString().slice(0, 10)
  try {
    const existing = await pb.collection(COL_NOTIFICATIONS).getList(1, 1, {
      filter: `recipient="${recipientId}" && type="${NOTIF_TYPE}" && created >= "${today} 00:00:00"`,
    })
    if (existing.items.length > 0) return
  } catch {
    /* продолжаем создание */
  }

  const count = overdue.length
  const word = count === 1 ? 'строка' : count < 5 ? 'строки' : 'строк'
  try {
    await pb.collection(COL_NOTIFICATIONS).create({
      recipient: recipientId,
      type: NOTIF_TYPE,
      title: 'Просроченные позиции в очереди',
      message: `${count} ${word} заявок просрочено по плану производства. Проверьте очередь планирования.`,
      read: false,
      link: '/planning/queue',
      relatedType: 'production_request_lines',
    })
  } catch {
    /* уведомление необязательно */
  }
}
